import { useEffect } from 'react';
import { hotjar } from 'react-hotjar';

import { HotJarIdByUrlProps } from '~/core/constants/hotjarIdByUrl';

const useHotJar = ({
  hotJarIdByUrl,
}: {
  hotJarIdByUrl: HotJarIdByUrlProps;
}): void => {
  useEffect(() => {
    Object.entries(hotJarIdByUrl).forEach(([key, value]) => {
      if (document.baseURI.match(new RegExp(key, 'i'))) {
        hotjar.initialize(value.hjid, value.hjsv);
      }
    });
  }, [hotJarIdByUrl]);
};

export default useHotJar;
